/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.MasterSearchReportItem = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The MasterSearchReportItem model module.
   * @module model/MasterSearchReportItem
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>MasterSearchReportItem</code>.
   * @alias module:model/MasterSearchReportItem
   * @class
   */
  var exports = function() {
    var _this = this;











  };

  /**
   * Constructs a <code>MasterSearchReportItem</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MasterSearchReportItem} obj Optional instance to populate.
   * @return {module:model/MasterSearchReportItem} The populated <code>MasterSearchReportItem</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Title')) {
        obj['Title'] = ApiClient.convertToType(data['Title'], 'String');
      }
      if (data.hasOwnProperty('ItemType')) {
        obj['ItemType'] = ApiClient.convertToType(data['ItemType'], 'Integer');
      }
      if (data.hasOwnProperty('ItemID')) {
        obj['ItemID'] = ApiClient.convertToType(data['ItemID'], 'Integer');
      }
      if (data.hasOwnProperty('MatchString')) {
        obj['MatchString'] = ApiClient.convertToType(data['MatchString'], 'String');
      }
      if (data.hasOwnProperty('DrillURI')) {
        obj['DrillURI'] = ApiClient.convertToType(data['DrillURI'], 'String');
      }
      if (data.hasOwnProperty('DateCreated')) {
        obj['DateCreated'] = ApiClient.convertToType(data['DateCreated'], 'Date');
      }
      if (data.hasOwnProperty('CreatorUserID')) {
        obj['CreatorUserID'] = ApiClient.convertToType(data['CreatorUserID'], 'Integer');
      }
      if (data.hasOwnProperty('Parameter1')) {
        obj['Parameter1'] = ApiClient.convertToType(data['Parameter1'], 'Integer');
      }
      if (data.hasOwnProperty('Parameter2')) {
        obj['Parameter2'] = ApiClient.convertToType(data['Parameter2'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Title
   * @default ''
   */
  exports.prototype['Title'] = '';
  /**
   * @member {Integer} ItemType
   * @default 0
   */
  exports.prototype['ItemType'] = 0;
  /**
   * @member {Integer} ItemID
   * @default 0
   */
  exports.prototype['ItemID'] = 0;
  /**
   * @member {String} MatchString
   * @default ''
   */
  exports.prototype['MatchString'] = '';
  /**
   * @member {String} DrillURI
   * @default ''
   */
  exports.prototype['DrillURI'] = '';
  /**
   * @member {Date} DateCreated
   */
  exports.prototype['DateCreated'] = undefined;
  /**
   * @member {Integer} CreatorUserID
   */
  exports.prototype['CreatorUserID'] = undefined;
  /**
   * @member {Integer} Parameter1
   */
  exports.prototype['Parameter1'] = undefined;
  /**
   * @member {Integer} Parameter2
   */
  exports.prototype['Parameter2'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


